import styled, { css } from 'styled-components'
import { CarouselProvider, Slider } from 'pure-react-carousel'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { SeoHref } from '../../common/footer/styles'

export const Container = styled.section`
    width: inherit;
    overflow: hidden;
    padding: 0.75rem 0rem 0.5rem 0rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1rem 0rem 0.5rem 0rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const TitleContainer = styled.div`
    padding-left: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding-left: 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding-left: 0;
    }
`

export const ListContainer = styled.div`
    position: relative;
`

export const SliderContainer = styled.div`
    position: relative;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0;
    }
`

export const StyledCarouselProvider = styled(CarouselProvider)`
    position: relative;
    touch-action: pan-y;
    li {
        list-style: none;
    }
`

export const StyledSlider = styled(Slider)<{ $transitionTime?: number }>(
    ({ $transitionTime }) => css`
        padding: 0.25rem 1rem 1rem;
        overflow: hidden;
        margin-top: 1rem;

        ul {
            transition: transform ${$transitionTime ? `${$transitionTime}s` : '0.5s'};
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
        }

        .carousel__slider-tray {
            display: flex;
            gap: 0.75rem;
        }

        .carousel__slide {
            width: auto !important;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 0.25rem 0 1rem;
            margin-top: 0.75rem;
            .carousel__slider-tray {
                gap: 0.75rem;
                padding-left: 0.1rem;
            }
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 0.5rem 0.1rem 1rem 0.1rem;
            margin-top: 1rem;
            .carousel__slider-tray {
                gap: 1rem;
            }
        }
    `,
)

export const PopularSearchCardWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-shrink: 0;
    min-width: 6.875rem;
    width: max-content;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        min-width: 7.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        min-width: 8rem;
    }
`

export const PopularSearchCard = styled(SeoHref)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 0.5rem;
    gap: 0.25rem;
    background-color: #ffffff;
    border-radius: 0.5rem;
    text-decoration: none;
    transition: all 0.2s ease;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 2px 1px rgba(0, 0, 0, 0.04), 0px 1px 5px rgba(0, 0, 0, 0.08);
    height: 7.625rem;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08), 0px 4px 2px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    &:focus {
        outline: 2px solid #0066cc;
        outline-offset: 2px;
    }

    &:focus-visible {
        outline: 2px solid #0066cc;
        outline-offset: 2px;
    }

    &:focus:not(:focus-visible) {
        outline: none;
    }
`

export const IconContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
`

export const Icon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`

export const Label = styled.div`
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    color: #282828;
    text-align: center;
    white-space: nowrap;
    font-feature-settings: 'liga' off, 'calt' off;
`

export const Country = styled.div`
    font-size: 0.75rem;
    line-height: 1rem;
    color: #6c6c6c;
    text-align: center;
    font-weight: 400;
    white-space: nowrap;
    font-feature-settings: 'liga' off, 'calt' off;
`
